var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Button, Dimmer, Loader, Message, Modal, Table } from "semantic-ui-react";
import GenerateReferralLinkModal from "../GenerateReferralLinkModal";
import { getWithAuthn } from "../RequestHelpers";
import AddReferralModal from "./AddReferralModal";
import ChangeReferralLinkVisibility from "./ChangeReferralLinkVisibility";
import SimpleFormWithErrorDisplay from "./SimpleFormWithErrorDisplay";
var MarketingReferralsPage = /** @class */ (function (_super) {
    __extends(MarketingReferralsPage, _super);
    function MarketingReferralsPage(props) {
        var _this = _super.call(this, props) || this;
        _this.loadMarketingReferrals = function () {
            _this.setState({ loading: true }, function () {
                getWithAuthn('/admin/marketing-referrals')
                    .then(function (resp) {
                    if (resp.status === 200) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                    else {
                        _this.setState({
                            loading: false,
                            marketingReferrals: resp
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load referrals: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            error: false
        };
        return _this;
    }
    MarketingReferralsPage.prototype.render = function () {
        var _this = this;
        var renderReferralModal = function (props) {
            return React.createElement(AddReferralModal, __assign({}, props));
        };
        return React.createElement(React.Fragment, null,
            React.createElement(Dimmer.Dimmable, { id: "non-header-portion" },
                React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                    React.createElement(Loader, null),
                    this.state.error &&
                        React.createElement(Message, { negative: true }, "Referrals could not be loaded.")),
                this.state.marketingReferrals &&
                    React.createElement(React.Fragment, null,
                        React.createElement(Modal, { closeIcon: true, onClose: this.loadMarketingReferrals, trigger: React.createElement(Button, { icon: 'plus', label: 'Add referral', labelPosition: 'left' }) },
                            React.createElement(Modal.Header, null, "Add Referral"),
                            React.createElement(Modal.Content, null,
                                React.createElement(SimpleFormWithErrorDisplay, { render: renderReferralModal, successMessage: 'Referral Added' }))),
                        React.createElement(Table, { striped: true, celled: true },
                            React.createElement(Table.Header, null,
                                React.createElement(Table.Row, null,
                                    React.createElement(Table.HeaderCell, null, "Referral Id"),
                                    React.createElement(Table.HeaderCell, null, "Referral Note"),
                                    React.createElement(Table.HeaderCell, null, "Bitly Link"),
                                    React.createElement(Table.HeaderCell, null, "Visible"))),
                            React.createElement(Table.Body, null, this.state.marketingReferrals.map(function (r, index) {
                                var renderGenerateLinkModal = function (props) {
                                    return React.createElement(GenerateReferralLinkModal, __assign({ referralId: r.referralId.id, referralType: r.referralId._type, admin: true }, props));
                                };
                                var renderChangeReferralLinkVisibility = function (valid) {
                                    return function (props) {
                                        return React.createElement(ChangeReferralLinkVisibility, __assign({ marketingReferralId: r.referralId.id, valid: valid }, props));
                                    };
                                };
                                var bitlyLinkDisplay = r.bitlyLink ? r.bitlyLink.replace("https://", "") : null;
                                var visibleNode = React.createElement(React.Fragment, null,
                                    "Yes ",
                                    React.createElement(Modal, { closeIcon: true, onClose: _this.loadMarketingReferrals, trigger: React.createElement(Button, { icon: 'eye slash', title: 'Make Invisible', labelPosition: 'left' }) },
                                        React.createElement(Modal.Header, null, "Make Referral Invisible"),
                                        React.createElement(Modal.Content, null,
                                            React.createElement(SimpleFormWithErrorDisplay, { render: renderChangeReferralLinkVisibility(false), successMessage: 'Referral Made Invisible' }))));
                                if (!r.valid) {
                                    visibleNode = React.createElement(React.Fragment, null,
                                        "No ",
                                        React.createElement(Modal, { closeIcon: true, onClose: _this.loadMarketingReferrals, trigger: React.createElement(Button, { icon: 'eye', title: 'Make Visible', labelPosition: 'left' }) },
                                            React.createElement(Modal.Header, null, "Make Referral Visible"),
                                            React.createElement(Modal.Content, null,
                                                React.createElement(SimpleFormWithErrorDisplay, { render: renderChangeReferralLinkVisibility(true), successMessage: 'Referral Made Visible' }))));
                                }
                                return React.createElement("tr", { key: index },
                                    React.createElement(Table.Cell, null, r.referralId.id),
                                    React.createElement(Table.Cell, null, r.referralNote),
                                    React.createElement(Table.Cell, null, r.bitlyLink === null ?
                                        React.createElement(Modal, { closeIcon: true, onClose: _this.loadMarketingReferrals, trigger: React.createElement(Button, { icon: 'plus', label: 'Generate link', labelPosition: 'left' }) },
                                            React.createElement(Modal.Header, null, "Generate Link"),
                                            React.createElement(Modal.Content, null,
                                                React.createElement(SimpleFormWithErrorDisplay, { render: renderGenerateLinkModal, successMessage: 'Referral Added' }))) : React.createElement("a", { href: r.bitlyLink }, bitlyLinkDisplay)),
                                    React.createElement(Table.Cell, null, visibleNode));
                            }))))));
    };
    MarketingReferralsPage.prototype.componentDidMount = function () {
        this.loadMarketingReferrals();
    };
    return MarketingReferralsPage;
}(React.Component));
export default MarketingReferralsPage;
//# sourceMappingURL=MarketingReferralsPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/MarketingReferralsPage.js
// module id = 1467
// module chunks = 0